// extracted by mini-css-extract-plugin
export default {"loading":"_4GeVAG6jFkxQZfhwdfUDui"};